import { Select } from '@iwoca/orion';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import { TGetStartedDataUK } from './GetStartedUK';
import styles from './GetStartedUK.module.css';

export const LOAN_PURPOSE_OPTIONS_UK = [
  {
    label: 'Purchasing stock',
    value: 'stock_purchase',
  },
  {
    label: 'Paying wages',
    value: 'pay_staff',
  },
  {
    label: 'Paying a bill',
    value: 'pay_bill',
  },
  {
    label: 'Refinancing debt',
    value: 'refinancing_debt',
  },
  {
    label: 'Growing my business',
    value: 'growing_business',
  },
  {
    label: 'Supporting cash flow',
    value: 'supporting_cashflow',
  },
  {
    label: 'Other purposes',
    value: 'other',
  },
  {
    label: 'No specific need',
    value: 'no_specific_need',
  },
] as const;

const LoanPurposeUK = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<TGetStartedDataUK>();

  return (
    <Select
      {...register('loanPurpose')}
      label="How will you use the funds?"
      placeholder="Please select"
      className={clsx({
        [styles.erroredSelect]: errors.loanPurpose?.message,
      })}
      error={errors.loanPurpose?.message}
    >
      {LOAN_PURPOSE_OPTIONS_UK.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );
};

export default LoanPurposeUK;
